import React, { useState } from 'react';
import { Star, User } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';

const GuestBook = () => {
  const { toast } = useToast();
  const [newReview, setNewReview] = useState({
    name: '',
    comment: '',
    rating: 5
  });

  // Avis des voyageurs (répartis sur les 3 dernières années, plusieurs langues)
  const reviews = [
    {
      name: "Sophie M.",
      date: "Juillet 2025",
      lang: "fr",
      rating: 5,
      comment: "Un séjour absolument merveilleux ! La villa est magnifique, parfaitement équipée et idéalement située. Le spa de nage est un vrai plus. Nous avons adoré l'emplacement calme, avec le golf au bout du jardin et les plages à quelques minutes. Les ânes Tom et Nomade sont adorables ! Nous reviendrons sans hésiter."
    },
    {
      name: "Sanne Visser",
      date: "Mei 2025",
      lang: "nl",
      rating: 5,
      comment: "Heerlijke vakantie gehad in deze schitterende villa. Alles was brandschoon en de bedden lagen uitstekend. De golfbaan ligt letterlijk achter de tuin en de mooiste stranden zijn dichtbij. De eigenaren waren zeer gastvrij. Wij komen zeker terug!"
    },
    {
      name: "Caroline & Marc V.",
      date: "Octobre 2024",
      lang: "fr",
      rating: 5,
      comment: "Séjour automnal magnifique. Les couleurs des marais salants sont superbes à cette saison. Villa chaleureuse, lumineuse et parfaitement équipée, et quel calme ! Le spa de nage chauffé est un vrai bonheur en soirée. Merci pour votre accueil si chaleureux."
    },
    {
      name: "The Harrington Family",
      date: "August 2024",
      lang: "en",
      rating: 5,
      comment: "A truly wonderful stay! The villa is spacious, immaculate and beautifully equipped. Being right next to the golf course — you simply walk there through the garden — was perfect for us. The heated swim spa was a highlight for the whole family. We can't wait to return!"
    },
    {
      name: "Familie de Vries",
      date: "Augustus 2024",
      lang: "nl",
      rating: 5,
      comment: "Een fantastisch verblijf! De villa is ruim, licht en perfect uitgerust. De verwarmde zwemspa was heerlijk. De ligging vlak bij de golfbaan en de mooiste stranden is ideaal, en alles is gelijkvloers. Zeker voor herhaling vatbaar!"
    },
    {
      name: "Jean-Pierre L.",
      date: "Août 2024",
      lang: "fr",
      rating: 5,
      comment: "Excellent séjour en famille. La maison est spacieuse et très confortable. Les 4 chambres permettent d'accueillir toute la famille. Le jardin est magnifique et le spa de nage a été très apprécié par les enfants comme par les adultes. Propriétaires très arrangeants."
    },
    {
      name: "Familie Müller",
      date: "Juli 2024",
      lang: "de",
      rating: 5,
      comment: "Ein traumhafter Aufenthalt! Die Villa ist geräumig, hell und hervorragend ausgestattet. Der beheizte Schwimmspa war besonders für die Kinder ein Highlight. Die Lage direkt am Golfplatz und in der Nähe der schönsten Strände ist perfekt. Wir kommen bestimmt wieder!"
    },
    {
      name: "Marie D.",
      date: "Juin 2024",
      lang: "fr",
      rating: 5,
      comment: "Villa exceptionnelle dans un cadre idyllique. Parfait pour les amateurs de golf et de plage. La villa est très bien entretenue et décorée avec goût. L'accueil a été chaleureux. Les plages de Trousse-Chemise et de la Patache sont à quelques minutes seulement."
    },
    {
      name: "Laurent P.",
      date: "Avril 2024",
      lang: "fr",
      rating: 5,
      comment: "Escapade de printemps parfaite. La villa est de plain-pied, très pratique, et le golf est littéralement au bout du jardin — un rêve pour les golfeurs ! Le spa de nage chauffé a été très apprécié même en avril. Nous reviendrons avec plaisir."
    },
    {
      name: "Isabelle R.",
      date: "Septembre 2023",
      lang: "fr",
      rating: 5,
      comment: "Séjour de rêve dans cette belle villa ! Tout est pensé pour passer d'excellentes vacances. L'environnement est paisible, les équipements sont de qualité. Les balades à vélo autour des marais salants sont magnifiques. Un grand merci aux propriétaires."
    },
    {
      name: "Famille Augerot",
      date: "Août 2023",
      lang: "fr",
      rating: 5,
      comment: "Nous avons été très bien accueillis et avons passé un superbe séjour dans la Villa Nomade, très bien placée, à côté des plus belles plages de l'île et des marais. La villa est également très bien équipée, vous trouverez tout ce dont vous avez besoin ! Le jardin est très grand et idéal pour les familles avec enfants, et le spa de nage est très utile. Un grand merci à Bernard et son épouse, notre séjour était parfait !"
    },
    {
      name: "James & Claire W.",
      date: "July 2023",
      lang: "en",
      rating: 5,
      comment: "One of the best holiday homes we've ever rented. Peaceful location, close to the stunning beaches of Trousse-Chemise and La Patache, with the golf course right by the garden. The owners were warm and incredibly helpful. Highly recommended!"
    },
    {
      name: "Jan & Anke Bakker",
      date: "Juli 2023",
      lang: "nl",
      rating: 5,
      comment: "Prachtig huis in een rustige omgeving. De eigenaren waren zeer vriendelijk en behulpzaam. Fietsen door de zoutmoerassen was een belevenis en de golfbaan grenst direct aan de tuin. Van harte aanbevolen!"
    },
    {
      name: "Séverine Gouault",
      date: "Juin 2023",
      lang: "fr",
      rating: 5,
      comment: "Nous avons passé un séjour fantastique dans cette maison magnifique, claire, lumineuse et hyper bien équipée. Le cadre est splendide, le spa vraiment très agréable. La maison est proche des plus belles plages de l'île et le propriétaire, qui vit à côté, est extrêmement sympathique et accueillant. Nous espérons revenir très vite !"
    },
    {
      name: "Thomas Becker",
      date: "Juni 2023",
      lang: "de",
      rating: 5,
      comment: "Sehr gepflegte Villa mit großem Garten und angenehmem, beheiztem Spa. Die Strände und die Salzwiesen sind mit dem Fahrrad schnell erreichbar, und der Golfplatz liegt direkt hinter dem Garten. Absolut empfehlenswert!"
    },
    {
      name: "Thomas B.",
      date: "Mai 2023",
      lang: "fr",
      rating: 4,
      comment: "Nous avons passé une semaine formidable à la Villa Nomade. L'emplacement est parfait pour visiter l'île de Ré tout en profitant du calme. Le spa est vraiment agréable, surtout en soirée. Un petit bémol sur le trafic en pleine saison, mais nous recommandons vivement cette location !"
    },
    {
      name: "Régine Morisson-Feret",
      date: "Octobre 2022",
      lang: "fr",
      rating: 5,
      comment: "Très agréable séjour entre amis dans cette jolie villa. L'emplacement est exceptionnel et calme, tout en étant proche des plages de la Patache et de Trousse-Chemise, au cœur de nombreux circuits vélo. La villa est très bien agencée, avec une grande pièce de vie lumineuse et 4 chambres réparties en 3 espaces distincts garantissant l'intimité de chacun. Les propriétaires sont charmants. Nous reviendrons !"
    },
    {
      name: "Famille Vincent",
      date: "Septembre 2022",
      lang: "fr",
      rating: 5,
      comment: "Nous avons passé un séjour très agréable dans cette villa. Le propriétaire est très sympa et accueillant. La villa est juste magnifique, bien équipée, propre, spacieuse et au calme. Notre seul regret : ne pas être restés plus longtemps. Nous vous la recommandons sans hésiter pour votre séjour sur la belle île de Ré."
    },
    {
      name: "Emma Thompson",
      date: "September 2022",
      lang: "en",
      rating: 5,
      comment: "Beautiful single-storey villa in a quiet, idyllic setting. Cycling around the salt marshes was magical and the golf course is just steps away. Everything was spotless and the beds were extremely comfortable. Thank you for a memorable week on the Île de Ré."
    },
    {
      name: "Familie Schneider",
      date: "August 2022",
      lang: "de",
      rating: 5,
      comment: "Wunderschönes Haus in ruhiger Lage. Die Gastgeber waren sehr herzlich und zuvorkommend. Ideal für einen Familienurlaub – alles ebenerdig, bestens ausgestattet und der Golfplatz liegt direkt am Garten. Vielen Dank für diesen tollen Urlaub!"
    }
  ];

  const langLabels = {
    fr: 'Français',
    en: 'English',
    de: 'Deutsch',
    nl: 'Nederlands'
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Avis envoyé !",
      description: "Merci pour votre témoignage.",
    });
    setNewReview({ name: '', comment: '', rating: 5 });
  };

  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, index) => (
      <Star
        key={index}
        className={`w-5 h-5 ${index < rating ? 'fill-amber-500 text-amber-500' : 'text-stone-300'}`}
      />
    ));
  };

  return (
    <div className="min-h-screen bg-stone-50 py-16 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-serif mb-4 text-stone-800">Livre d'Or</h1>
          <p className="text-lg text-stone-600">Les témoignages de nos hôtes</p>
        </div>

        {/* Add Review Form */}
        <Card className="shadow-lg border-none mb-12">
          <CardContent className="p-8">
            <h3 className="text-2xl font-serif mb-6 text-stone-800">Partagez votre expérience</h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="reviewName" className="text-stone-700">Votre nom *</Label>
                <Input
                  id="reviewName"
                  value={newReview.name}
                  onChange={(e) => setNewReview({ ...newReview, name: e.target.value })}
                  required
                  className="mt-1"
                  placeholder="Votre nom"
                />
              </div>

              <div>
                <Label className="text-stone-700 mb-2 block">Note *</Label>
                <div className="flex gap-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setNewReview({ ...newReview, rating: star })}
                      className="transition-all duration-200 hover:scale-110"
                    >
                      <Star
                        className={`w-8 h-8 ${star <= newReview.rating ? 'fill-amber-500 text-amber-500' : 'text-stone-300'}`}
                      />
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <Label htmlFor="reviewComment" className="text-stone-700">Votre avis *</Label>
                <Textarea
                  id="reviewComment"
                  value={newReview.comment}
                  onChange={(e) => setNewReview({ ...newReview, comment: e.target.value })}
                  required
                  rows={5}
                  className="mt-1"
                  placeholder="Partagez votre expérience..."
                />
              </div>

              <Button
                type="submit"
                className="bg-amber-700 hover:bg-amber-800 text-white px-8 py-6 text-lg transition-all duration-300 hover:scale-105"
              >
                Publier l'Avis
              </Button>
            </form>
          </CardContent>
        </Card>

        {/* Reviews List */}
        <div className="space-y-6">
          <h3 className="text-2xl font-serif text-stone-800 mb-6">Avis des Voyageurs</h3>
          {reviews.map((review, index) => (
            <Card key={index} className="shadow-md border-none hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="bg-amber-100 p-3 rounded-full">
                    <User className="w-6 h-6 text-amber-700" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <h4 className="font-semibold text-stone-800 text-lg">{review.name}</h4>
                        <div className="flex items-center gap-2">
                          <p className="text-sm text-stone-500">{review.date}</p>
                          <span className="text-xs font-medium text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">
                            {langLabels[review.lang] || 'Français'}
                          </span>
                        </div>
                      </div>
                      <div className="flex gap-1">
                        {renderStars(review.rating)}
                      </div>
                    </div>
                    <p className="text-stone-700 leading-relaxed">{review.comment}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GuestBook;